'use client';

import { Book } from 'types';
import CartCallout from '@/components/product/callouts/cart-callout';

interface CartCalloutProps {
  bookData: Book;
}
export default function CartCalloutClient({ bookData }: CartCalloutProps) {
  return <CartCallout book={bookData} />;
}